import { useSelector, useDispatch } from "react-redux";

import "./style.css";
import { MapLocation } from "../../components/map";
import { OrderDetailedResumed } from "../../components/orderDetailedResumed";
import {DirectionsLink} from "../../components/directionsLink";
import {deliveryAddress} from "../../utils/deliveryAddress";
import { IoMdClose } from "react-icons/io";
import { setComponentActive } from "../../reducers/userConfigSlice";

export const OrderResumedMap = () => {
  const order = useSelector((state) => state.aplicationConfig.userConfig.order);

  const dispatch = useDispatch();

  const handleNavigation = (component) => {
    dispatch(setComponentActive("" + component));
  };

  const fullAddress = deliveryAddress(order.address);

  return (
    <div>
      <div className="backgroundContent deliveryMapContext">
        {fullAddress ? <MapLocation address={fullAddress} /> : <div className="no-map-available">El mapa no está disponible en esta dirección</div>}
      </div>
      <div className="orderFloat">
        <div className="how-go">
          <DirectionsLink address={order.address}/>
        </div>
        <OrderDetailedResumed data={order} />
      </div>
      <button type="button" aria-label="Cerrar mapa y volver a entregas" className="deliveryMapClose" onClick={() => handleNavigation("delivery")}><IoMdClose aria-hidden="true"/></button>
    </div>
  );
};
